import type {ProjectScope} from 'src/redux/slices/projectScopeSlice';
import {useAppSelector} from 'src/redux/hooks';

// Ambient sidebar project scope. Non-null means every list request is already
// narrowed server-side, so pages must not add their own project filter.
export const useProjectScope = (): ProjectScope | null =>
  useAppSelector(state => state.projectScope.scope);
